import styled from 'styled-components'
import { GlobalContainer } from '../../../../components/GlobalContainer'
import SimpleLink from '../../../../components/SimpleLink'

export const BackTo = styled(SimpleLink)`
  align-self: flex-start;
  font-weight: bold;
`

export const AddEditFooter = styled.div`
  ${GlobalContainer}
  margin-top: 12px;
`

export const NoModemContainer = styled.div`
  margin: 2%;
`
